import { Globals } from "../CoreApp/Globals";

export function InitDecimalMarker() {
  var m = 3.3;
  var result = m.toLocaleString();
  var decPos = result.indexOf(".");
  if (decPos === -1) Globals._decimalMarker = ",";
  else Globals._decimalMarker = ".";
}
